import React, { Component } from 'react';
import axios from 'axios';
import {
  NavLink,
  Redirect
} from 'react-router-dom';


class Profile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      date: '',
      sunumlar: []
    }
  }

  componentDidMount() {
    var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
    var auth2 = "aGFzYW46SCo4NzM3MzIzKm4=";
  
  	console.log(auth);
  	console.log(auth);
  
    var self = this;
    this.serverRequest = axios.get('https://api.efeskiyafetportali.com/user/' + uid + '?_format=json', {
      headers: {"Authorization":"Basic " + auth}
    })
    .then(function(result){
      var userDate = new Date(parseInt(result.data.created["0"].value, 10)*1000);
      self.setState({
        'name': result.data.name["0"].value,
        'user_picture': result.data.user_picture["0"].url,
        'date': userDate.toISOString()
      });
    })

  }

  render(){
    const { sunumlar } = this.state;
    return (
    <div className="position-relative">
      <div className="row  justify-content-center pt-5">
        <div className="col-md-5 mb-5">
          <div className="list-group mb-3">
            <a href="#" className="list-group-item list-group-item-action list-group-item-success">
              Kullanıcı Profili
            </a>
          </div>
          <div className="list-group mb-3">
            <a href="#" className="list-group-item list-group-item-action"><strong>Kullanıcı Fotoğrafı:</strong>&nbsp;
          	
            	<img className="img-fluid rounded-circle" src={`${this.state.user_picture}`} />
          	
          	</a>
            <a href="#" className="list-group-item list-group-item-action"><strong>Kullanıcı Adı:</strong>&nbsp;{this.state.name}</a>
          </div>


        </div>
        <div className="col-md-5 ">
            {sunumlar.map(article =>
                <div className="list-group mb-3" key={article.title}>
                    <br/>
                    <div className="list-group-item list-group-item-action"><span>Sunum Cevaplar:</span> <NavLink to={`/sunum-${article.type.toLowerCase()}/${article.uuid}`}>{article.title}</NavLink></div>
                    <div className="list-group-item list-group-item-action"><span>Sunum Sorular:</span> <a target="_blank" href={`https://sorular.recordatifocus.com/${article.type.toLowerCase()}/${article.uuid}`}>{article.title}</a></div>
                    <div className="list-group-item list-group-item-action"><span>Sunum Link:</span> <a target="_blank" href={`https://slide.recordatifocus.com/${article.type.toLowerCase()}/${article.uuid}`}>{article.title}</a></div>
                    <div className="list-group-item list-group-item-action"><span>Sunum Tipi:</span> {article.type}</div>
                    <div className="list-group-item list-group-item-action"><span>Tarih:</span> {article.created}</div>
                </div>
            )}
        
    	</div>
      </div>
<div class="cube-code bottom-0 end-0 translate-middle-y d-inline-flex"><p class="p-0 small text-center rotated"></p></div>
</div>
    );
  }
}

export default Profile



// WEBPACK FOOTER //
// src/components/profile.jsx